<template>

  <section class="list">
    <div v-for="(single, index) in resume" :key="index" class="list__single">
      <h2 class="list__single__title">{{ single.title }}</h2>
      <div v-for="(list, index) in single.list" :key="index" class="list__single__list">
        <h3 v-if="list.title"
            class="list__single__list__title"
            :class="{ 'list__single__list__title--small' : list.skills }">
          {{ list.title }}
        </h3>
        <div v-if="list.subtitle" class="list__single__list__subtitle">{{ list.subtitle }}</div>
        <div v-if="list.info" class="list__single__list__info">{{ list.info }}</div>
        <div v-if="list.description" class="list__single__list__description">{{ list.description }}</div>
        <div v-if="list.skills" class="list__single__list__skills">
          <div v-for="(skill, index) in list.skills" :key="index" class="list__single__list__skills__single">
            {{ skill }}
          </div>
        </div>
        <a v-if="list.link" :href="`http://${ list.link }`" class="list__single__list__link" target="_blank">{{ list.link }}</a>
      </div>
    </div>
  </section>

</template>

<script>

  import resume from '@/data/resume.json'

  export default {
    name: 'ResumeList',
    computed: {
      resume() {
        return resume.map(result => {
          return result
        })
      }
    }
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .list {
    @include container;
    align-items: flex-end;
    flex-direction: column;
  }

  .list__single {
    width: 50%;
    margin-right: 100px;
    margin-bottom: 80px;

    @include mq(medium) {
      width: 100%;
      margin-right: 0px;
    }

    &:last-child {
      .list__single__list {
        margin-bottom: 20px;
      }

      .list__single__list__title {
        margin-bottom: 5px;
      }

      .list__single__list__info {
        padding-left: 30px;
      }
    }
  }

  .list__single__title {
    @include ui(back);
    margin-bottom: 20px;
  }

  .list__single__list {
    margin-bottom: 50px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .list__single__list__title {
    @include title(small);
    padding-left: 30px;
    margin-bottom: 10px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 5px;
      left: 0;
      width: 20px;
      height: 20px;
      border: 2px solid $dark;
      border-radius: 50%;
    }

    &:after {
      content: '*';
      position: absolute;
      top: 8px;
      left: 0px;
      width: 20px;
      font-size: 15px;
      line-height: 20px;
      text-align: center;
    }
  }

  .list__single__list__title--small {
    @include ui(big);
    font-family: 'Circular-Bold';
    text-transform: uppercase;
  }

  .list__single__list__subtitle {
    @include current(big);
    margin-bottom: 10px;
  }

  .list__single__list__info {
    @include ui(big);
  }

  .list__single__list__description {
    @include current(big);
    padding-top: 20px;
  }

  .list__single__list__skills {
  }

  .list__single__list__skills__single {
    @include title(smaller);
  }

  .list__single__list__link {
    @include ui(big);
    padding-top: 20px;
    display: inline-block;
  }

</style>
